module.exports = __webpack_public_path__ + "static/media/3d-model-icon.b98f78e3.svg";